import styled from "styled-components";

export const DepartmentMemberModalStyled = styled.div`
  width: 594px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 12px;
  padding: 24px;
  position: relative;

  .modal_close {
    position: absolute;
    top: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    cursor: pointer;
    background: none;
    border: none;
  }

  .modal_header {
    display: flex;
    align-items: center;
    gap: 24px;
    padding-right: 40px;
    margin-bottom: 20px;
  }

  .modal_title_block {
    .dept_th {
      font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }

    .dept_en {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
    }
  }

  .modal_divider {
    width: 1px;
    align-self: stretch;
    min-height: 48px;
    background: ${({ theme }) => theme.COLORS.GRAY_22};
    flex-shrink: 0;
  }

  .modal_count_block {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    justify-content: space-between;
    .count_text_col {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .count_label_th {
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
    }

    .count_label_en {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.GRAY_26};
    }

    .count_value {
      font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      white-space: nowrap;
      
    }
  }

  .modal_tabs {
    display: flex;
    gap: 32px;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_5};
    margin-bottom: 16px;
  }

  .modal_tab {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD} !important;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    padding: 8px 0;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    margin-bottom: -1px;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
  }

  .modal_tab_active {
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    border-bottom-color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .modal_body_content {
    height: 430px;
    overflow-y: auto;
  }

  .member_name_cell {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .member_avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${({ theme }) => theme.COLORS.GRAY_28};
    flex-shrink: 0;
  }

  .member_steps {
    display: flex;
    gap:12px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    justify-content: flex-end;
  }

  .steps_value {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .steps_unit {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .modal_loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
  }

`;
